export default {
    API_URL: 'https://api.painel.canalhigieneocupacional.com.br/',
    CLIENT_SECRET: 'uZo1xKdxvmEEaajcWuZTkVYUB8IHCci2LbVIneVF',
    GRANT_TYPE: 'password',
    CLIENT_ID: '2',
    PUSHER_APP_KEY: '66824d8739c0181af28e',
    PUSHER_APP_CLUSTER: 'mt1',
    UPLOAD_LIMIT: 5,
};
